module.exports = __webpack_public_path__ + "img/pic_home_technology.b3593a48.jpg";